import React, { useContext, useEffect, useState, useRef } from "react";
import ChevronLeftIcon from "@assets/svg/ChevronLeftIcon";
import ChevronRightIcon from "@assets/svg/ChevronRightIcon";
import { useSelector } from "react-redux";
import { userTypes } from "@utils/constants";
import AddAvailabilityModal from "./components/AddAvailabilityModal";
import { CalendarContext } from "@pages/CalendarsPage/MeetingLayout";
import dayjs from "dayjs";

const CustomWeekTimeCalendar = ({ onPressDateSlot = null }) => {
  const { user } = useSelector((state) => state?.auth);
  const isRecruiter =
    user?.userType === userTypes.RECRUITER ||
    user?.userType === userTypes.HIRING_COMPANY;

  // const {
  //   setActiveWeeks,
  //   events,
  //   setEvents,
  //   availabilities,
  //   unAvailabilities,
  // } = useContext(isRecruiter ? CalendarContext : CandidateCalendarContext);
  const {
    setActiveWeeks,
    events,
    setEvents,
    availabilities,
    unAvailabilities,
  } = useContext(CalendarContext);
  //  const  availabilities=[]
  //   const  unAvailabilities=[]
  //   const [events, setEvents] = useState({});
  //   const [activeWeeks, setActiveWeeks] = useState();

  const [weekStart, setWeekStart] = useState(dayjs().startOf("day"));
  const [showAddAvailabilityForm, setShowAddAvailabilityForm] = useState(false);
  const [currentTime, setCurrentTime] = useState(dayjs());
  const gridRef = useRef(null);

  const hours = Array.from({ length: 24 }, (_, i) => i); // 0-23
  const timeSlots = Array.from({ length: 48 }, (_, i) => i * 30); // 30-minute intervals

  const days = Array.from({ length: 7 }, (_, i) =>
    weekStart.clone().add(i, "day")
  );

  // console.log("checking events", events);

  const handleSlotClick = (day, minutes) => {
    const slot = day.clone().startOf("day").add(minutes, "minutes");
    const startTime = prompt(`Enter start time (HH:mm)`, slot.format("HH:mm"));
    if (!startTime) return;

    const endTime = prompt(
      `Enter end time (HH:mm)`,
      dayjs(slot).add(1, "hour").format("HH:mm")
    );
    if (!endTime) return;

    const title = prompt(`Add event title`);
    if (!title) return;

    const key = slot.format("YYYY-MM-DD");
    setEvents((prev) => ({
      ...prev,
      [key]: [
        ...(prev[key] || []),
        {
          title,
          startTime: dayjs(slot.format("YYYY-MM-DD") + " " + startTime),
          endTime: dayjs(slot.format("YYYY-MM-DD") + " " + endTime),
          id: Math.random().toString(36).substr(2, 9),
        },
      ],
    }));
  };

  const getEventsForDay = (day) => {
    const key = day.format("YYYY-MM");
    const listOfEventsForTheMonth = events[key];
    const filteredData = listOfEventsForTheMonth?.filter((event) => {
      // if (event?.slotSelectionType === "general") {
      //   return true;
      // } else {
      //   return dayjs(day).isSame(event?.startDate, "date");
      // }
      return dayjs(day).isSame(event?.startTime, "day");
    });
    return filteredData || [];
  };

  const getAvailabilitiesForDay = (day, data) => {
    const key = day.format("YYYY-MM-DD");
    return (
      data?.filter(
        (item) => dayjs(item?.startTime).format("YYYY-MM-DD") === key
      ) || []
    );
  };

  const calculateEventPosition = (event) => {
    const startMinutes =
      dayjs(event.startTime).get("hours") * 60 +
      dayjs(event.startTime).get("minutes");
    const endMinutes =
      dayjs(event.endTime).get("hours") * 60 +
      dayjs(event.endTime).get("minutes");
    const duration = endMinutes - startMinutes;

    const top = (startMinutes / 60) * 60; // 60px per hour
    const height = (duration / 60) * 60;

    return {
      top: `${top}px`,
      height: `${height}px`,
    };
  };

  const isToday = (day) => {
    return day.isSame(dayjs(), "day");
  };

  const isPastLimit = weekStart
    .clone()
    .startOf("week")
    .isSameOrBefore(dayjs().startOf("week"));

  const getCurrentTimeLinePosition = () => {
    const currentMinutes = currentTime.hour() * 60 + currentTime.minute();
    return {
      top: `${(currentMinutes / 60) * 60}px`,
      left: "0",
      right: "0",
      position: "absolute",
      zIndex: 20,
    };
  };

  const scrollToCurrentTime = () => {
    if (gridRef.current) {
      const currentMinutes = currentTime.hour() * 60 + currentTime.minute();
      const scrollPosition = (currentMinutes / 60) * 60 - 200; // 200px offset from top
      gridRef.current.scrollTop = Math.max(0, scrollPosition);
    }
  };

  useEffect(() => {
    setActiveWeeks(days);
  }, [weekStart]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(dayjs());
      scrollToCurrentTime();
    }, 60000); // Update every minute

    // Initial scroll
    scrollToCurrentTime();

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (isToday(weekStart)) {
      scrollToCurrentTime();
    }
  }, [weekStart]);

  // console.log("availabilities", availabilities, unAvailabilities);
  // console.log("checking events", events);
  // console.log('week start',weekStart)

  return (
    <div className="w-full bg-white border h-full">
      {/* Header */}
      <div className="flex justify-between items-center px-2.5 sticky top-0 z-20">
        <div className="flex items-center w-full justify-between">
          <button
            onClick={() => {
              setWeekStart(weekStart.clone().subtract(1, "week"));
            }}
            className={`p-2 hover:bg-gray-100 rounded-full`}
          >
            <ChevronLeftIcon className={"w-5 h-5"} fill={"#2e2e2e"} />
          </button>

          <h2 className="text-sm font-semibold text-gray-900">
            {weekStart.format("MMMM")}
          </h2>
          <button
            onClick={() => setWeekStart(weekStart.clone().add(1, "week"))}
            className="p-2 hover:bg-gray-100 rounded-full"
          >
            <ChevronRightIcon className={"w-5 h-5"} fill={"#2e2e2e"} />
          </button>
        </div>
      </div>

      {/* Grid */}
      <div
        ref={gridRef}
        className="relative h-[calc(100vh-200px)] overflow-auto"
      >
        {/* Days Header */}
        <div className="grid grid-cols-[0.5fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr] text-sm sticky top-0 bg-white z-10">
          <div className="h-[35px]"></div>
          {days?.map((day) => (
            <div
              key={day.format("YYYY-MM-DD")}
              className={`flex items-center gap-2 justify-center ${
                isToday(day) ? "bg-blue-50" : ""
              }`}
            >
              <div className="text-xss font-medium">{day.format("ddd")}</div>
              <div
                className={`h-4 w-4 flex items-center justify-center rounded-full font-medium text-xss ${
                  isToday(day)
                    ? "bg-secondary text-white"
                    : "bg-gray-100 text-gray-500 hover:bg-gray-100"
                }`}
              >
                {day.format("D")}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-[0.5fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr] text-sm">
          {/* Time Column */}
          <div className="sticky left-0 z-10 bg-white">
            {hours.map((hour) => (
              <div
                key={hour}
                className="h-[60px] pr-2 flex items-start justify-center"
              >
                <span className="text-[10px] text-gray-500 font-medium text-center">
                  {dayjs().hour(hour).minute(0).format("HH:mm")}
                </span>
              </div>
            ))}
          </div>

          {/* Day Columns */}
          {days.map((day) => (
            <div
              key={day.format("YYYY-MM-DD")}
              className={`flex flex-col relative border-l ${
                isToday(day) ? "bg-blue-50/30" : ""
              }`}
            >
              {/* Current Time Line */}
              {isToday(day) && (
                <div
                  className="absolute left-0 right-0 h-0.5 bg-green-500 z-20"
                  style={getCurrentTimeLinePosition()}
                >
                  <div className="absolute -left-2 -top-1.5 w-3 h-3 bg-green-500 rounded-full"></div>
                  <div className="absolute -right-2 -top-1.5 w-3 h-3 bg-green-500 rounded-full"></div>
                </div>
              )}

              {/* Time Slots */}
              {timeSlots.map((minutes) => (
                <div
                  key={`${day}-${minutes}`}
                  className={`h-[30px] ${
                    minutes % 60 === 0
                      ? "border-t border-gray-300"
                      : "border-t border-gray-100"
                  } hover:bg-gray-50/70 cursor-pointer relative group`}
                  onClick={() => {
                    onPressDateSlot &&
                      onPressDateSlot({
                        date: day.toISOString(),
                        timeInMinutes: minutes,
                      });
                  }}
                  // onClick={() => setShowAddAvailabilityForm(true)}
                >
                  <div className="absolute left-0 w-full h-full opacity-0 group-hover:opacity-100 pointer-events-none">
                    <div className="absolute left-0 right-0 h-0.5 bg-blue-600 top-0"></div>
                  </div>
                </div>
              ))}

              {/* Events */}
              {getEventsForDay(day).map((event) => {
                const position = calculateEventPosition(event);
                return (
                  <div
                    key={event.id}
                    className="absolute left-1 right-1 rounded bg-blue-600/95 hover:bg-blue-700 text-white shadow-sm cursor-pointer"
                    style={position}
                  >
                    <div className="p-1 text-xs overflow-hidden">
                      <div className="font-medium text-xss leading-tight">
                        {event.meetingTitle}
                      </div>
                      <div className="opacity-90 text-xss font-medium">
                        {dayjs(event.startTime).format("HH:mm")} -{" "}
                        {dayjs(event.endTime).format("HH:mm")}
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Availabilities */}
              {getAvailabilitiesForDay(day, availabilities)?.map((event) => {
                const position = calculateEventPosition(event);
                return (
                  <div
                    key={event.id}
                    className="absolute left-1 right-1 rounded bg-green-500 text-white shadow-sm cursor-pointer"
                    style={position}
                  >
                    <div className="p-1 text-xs overflow-hidden">
                      <div className="font-medium leading-tight">Available</div>
                      <div className="opacity-90 text-[10px]">
                        {dayjs(event?.startTime).format("h:mm A")} -{" "}
                        {dayjs(event?.endTime).format("h:mm A")}
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Unavailabilities */}
              {getAvailabilitiesForDay(day, unAvailabilities)?.map((event) => {
                const position = calculateEventPosition(event);
                return (
                  <div
                    key={event.id}
                    className="absolute left-1 right-1 rounded bg-red-600 text-white shadow-sm cursor-pointer"
                    style={position}
                  >
                    <div className="p-1 text-xs overflow-hidden">
                      <div className="font-medium leading-tight">
                        Unavailable
                      </div>
                      <div className="opacity-90 text-[10px]">
                        {dayjs(event?.startTime).format("h:mm A")} -{" "}
                        {dayjs(event?.endTime).format("h:mm A")}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
          {/* Add Availability Modal */}
          <AddAvailabilityModal
            showModal={showAddAvailabilityForm}
            setShowModal={setShowAddAvailabilityForm}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomWeekTimeCalendar;
